<template>
  <lr-link class="video-banner" :to="url" target="_blank">
    <img :src="image" />
    <close-btn
      class="video-banner-close"
      @click.prevent.stop="onClose"
    ></close-btn>
  </lr-link>
</template>

<script>
export default {
  props: {
    url: String,
    image: String,
  },

  methods: {
    onClose(e) {
      this.$emit('close', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-banner {
  position: relative;
  display: block;
  cursor: pointer;

  > img {
    display: block;
    width: 100%;
  }

  &-close {
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
</style>